/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
let resourceBaseUrl = '/resources';
export const resourceUrl = (path = '') => `${resourceBaseUrl}${path[0] === '/' ? path : path && `/${path}`}`;
export const setResourceBaseUrl = (baseUrl = '') => resourceBaseUrl = baseUrl;
//# sourceMappingURL=resourceBaseUrl.js.map